// extracted by mini-css-extract-plugin
module.exports = {"correction":"correction-serie_correction__3jp53","disabled":"correction-serie_disabled__YE9wU"};